import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { GenericResponse, PromoCode } from '../domain/registrator';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class PromocodeService {
  endpoint: string = environment.api_url;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  private cache$!: Observable<Array<Event>>;
  private cacheDirty: boolean = true;

  constructor(private http: HttpClient, private messageService: MessageService) { }


  getEventPromocodes(eventShortName: string, filter?: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    // const params = new HttpParams().set('statusFilter', statuses.join(','));
    const params = new HttpParams();

    return this.http.get<PromoCode[]>(`${this.endpoint}/events/${eventShortName}/codes`, { params, headers }).pipe(
      // Map the response array, converting date strings to Date objects.
      // Dates are sent by backend as UTC ISO8601 strings, without timezone
      // It may sound like a hack, but adding "Z" at the end makes it a UTC timestamp 
      map((response: PromoCode[]) => {
        return response.map(item => new PromoCode(
          item.id,
          item.code,
          item.description,
          item.discountType,
          item.discountValue,
          DateTime.fromISO(item.validUntil, { zone: 'Europe/Brussels' }).toISODate()!,
          item.uses,
          item.maxUses,
          item.active
        ))
      }),
      tap((promocodes: PromoCode[]) => { // The tap operator now receives the converted Registration[]
        this.cacheDirty = false;
      }),
      catchError(err => {
        console.error('Promo code validation failed:', err);
        return throwError(() => new Error('Promo codes fetch failed'));
      }));
  }

  getEventPromocode(eventShortName: string, code: string): Observable<PromoCode> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const params = new HttpParams();
    return this.http.get<PromoCode>(`${this.endpoint}/events/${eventShortName}/codes/${code}`, { params, headers }).pipe(
      map(item => new PromoCode(
        item.id,
        item.code,
        item.description,
        // Code type comes as string from backend, but TS enum allows that
        item.discountType,
        item.discountValue,
        DateTime.fromISO(item.validUntil, { zone: 'Europe/Brussels' }).toISODate()!,
        item.uses,
        item.maxUses,
        item.active)),
      catchError(err => {
        console.error('Promo code fetch failed:', err);
        if (err.status == 400) {
          return throwError(() => new Error('Promo code not valid'));
        }
        if (err.status === 404) {
          return throwError(() => new Error('Promo code not found'));
        }
        return throwError(() => new Error('Promo code fetch failed'));
      })
    );
  }

  generatePromoCodes(eventShortName: string, request: any): Observable<void | GenericResponse> {
    return this.http.post<GenericResponse>(`${this.endpoint}/events/${eventShortName}/codes/generate`, request);
  }

  addPromoCode(eventShortName: string, request: any): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(`${this.endpoint}/events/${eventShortName}/codes`, request);
  }

  updatePromoCode(eventShortName: string, codeId: number, request: any): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(`${this.endpoint}/events/${eventShortName}/codes/${codeId}`, request);
  }

  togglePromoCode(eventShortName: string, codeId: number): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(`${this.endpoint}/events/${eventShortName}/codes/${codeId}`, {});
  }

  deletePromoCode(eventShortName: string, codeId: number): Observable<void | GenericResponse> {
    return this.http.delete<void>(`${this.endpoint}/events/${eventShortName}/codes/${codeId}`);
  }



  // private handleError(operation = 'operation'): (error: any) => Observable<GenericResponse> {
  //   return (error: any): Observable<GenericResponse> => {
  //     const statusCode = error?.status || 'Unknown status';
  //     let errorMessage = 'An unexpected error occurred';

  //     if (error?.error instanceof ArrayBuffer) {
  //       // Handle the case of a request that expects an arraybuffer but gets an error
  //       // which is interpreted as an array buffer
  //       try {
  //         const decodedText = new TextDecoder().decode(error.error);
  //         const errorJson = JSON.parse(decodedText);
  //         errorMessage = errorJson?.message || 'An unexpected error occurred';
  //       } catch (e) {
  //         console.error('Failed to parse error body as JSON:', e);
  //       }
  //     } else if (error?.error?.message) {
  //       errorMessage = error.error.message;
  //     } else if (error.message) {
  //       errorMessage = error.message;
  //     }
  //     const response: GenericResponse = { status: 'error', message: errorMessage };
  //     return of(response); // Returns Observable<GenericResponse>
  //   };
  // }

}
